<mat-drawer-container [dir]="dir$ | async"
  [hasBackdrop]="false"
  class="content-container">

  <mat-drawer-content>
    <ng-content></ng-content>
  </mat-drawer-content>
  <mat-drawer #drawer
    mode="over"
    [opened]="opened"
    position="end"
    class="content-container__side">
    <div class="d-flex justify-content-start content-container__close-header">
      <button mat-icon-button
        (click)="onClose()">
        <mat-icon fontSet="material-icons-outlined">clear</mat-icon>
      </button>
    </div>
    <ng-content select="app-questions-container-side"></ng-content>
  </mat-drawer>


</mat-drawer-container>
